import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';
import Sidebar from '../../components/shared/Sidebar';
import { FiArrowLeft } from 'react-icons/fi';

export default function AdminAddShop() {
  const [plans, setPlans] = useState([]);
  const [form, setForm] = useState({ shop_name: '', owner_name: '', email: '', password: '', phone: '', whatsapp_number: '', address: '', city: '', plan_id: '', billing_cycle: 'monthly', subscription_days: 30, shop_type: 'barber' });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const set = (k, v) => setForm(f => ({...f, [k]: v}));

  useEffect(() => { axios.get('/api/admin/plans').then(r => setPlans(r.data)); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      const r = await axios.post('/api/admin/shops', form);
      toast.success(`${form.shop_name} successfully add ho gayi!`);
      navigate(`/admin/shops/${r.data.id}`);
    } catch (err) { toast.error(err.response?.data?.message || 'Error'); }
    setLoading(false);
  };

  return (
    <div className="app-layout">
      <Sidebar />
      <div className="main-content">
        <div className="flex gap-3 page-header">
          <Link to="/admin/shops" className="btn btn-outline btn-sm"><FiArrowLeft /></Link>
          <div><h1>Naya Shop Add Karein</h1><p>Shop ka account banayein</p></div>
        </div>

        <div className="card" style={{ maxWidth: '700px' }}>
          <form onSubmit={handleSubmit}>
            <h3 style={{ marginBottom: '20px', color: 'var(--primary)' }}>🏪 Shop Information</h3>
            <div className="grid-2">
              <div className="form-group">
                <label className="form-label">Shop Name *</label>
                <input className="form-control" value={form.shop_name} onChange={e => set('shop_name', e.target.value)} placeholder="e.g. Shop ka naam" required />
              </div>
              <div className="form-group">
                <label className="form-label">Owner Name *</label>
                <input className="form-control" value={form.owner_name} onChange={e => set('owner_name', e.target.value)} placeholder="e.g. Ahmed Khan" required />
              </div>
              <div className="form-group">
                <label className="form-label">Email (Login ke liye) *</label>
                <input type="email" className="form-control" value={form.email} onChange={e => set('email', e.target.value)} required />
              </div>
              <div className="form-group">
                <label className="form-label">Password *</label>
                <input type="password" className="form-control" value={form.password} onChange={e => set('password', e.target.value)} minLength={6} required placeholder="Min 6 characters" />
              </div>
              <div className="form-group">
                <label className="form-label">Phone Number</label>
                <input className="form-control" value={form.phone} onChange={e => set('phone', e.target.value)} placeholder="03XX-XXXXXXX" />
              </div>
              <div className="form-group">
                <label className="form-label">WhatsApp Number *</label>
                <input className="form-control" value={form.whatsapp_number} onChange={e => set('whatsapp_number', e.target.value)} placeholder="923XXXXXXXXX (country code ke saath)" required />
                <small style={{ color: 'var(--text-light)', fontSize: '11px' }}>Customers is number pe book karenge</small>
              </div>
              <div className="form-group">
                <label className="form-label">City</label>
                <input className="form-control" value={form.city} onChange={e => set('city', e.target.value)} placeholder="e.g. Karachi" />
              </div>
              <div className="form-group">
                <label className="form-label">Address</label>
                <input className="form-control" value={form.address} onChange={e => set('address', e.target.value)} placeholder="Poora address" />
              </div>
            </div>

            <h3 style={{ margin: '24px 0 16px', color: 'var(--primary)' }}>💳 Subscription</h3>
            <div className="grid-3">
              <div className="form-group">
                <label className="form-label">Plan *</label>
                <select className="form-control" value={form.plan_id} onChange={e => set('plan_id', e.target.value)} required>
                  <option value="">— Plan Select Karein —</option>
                  {plans.map(p => <option key={p.id} value={p.id}>{p.display_name} — PKR {Number(p.monthly_price).toLocaleString()}/mo</option>)}
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">Shop Type</label>
                <select className="form-control" value={form.shop_type} onChange={e => set('shop_type', e.target.value)}>
                  <option value="barber">Barber Shop</option>
                  <option value="parlour">Beauty Parlour</option>
                  <option value="dentist">Dental Clinic</option>
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">Billing Cycle</label>
                <select className="form-control" value={form.billing_cycle} onChange={e => set('billing_cycle', e.target.value)}>
                  <option value="monthly">Monthly</option>
                  <option value="quarterly">Quarterly (3 months)</option>
                  <option value="yearly">Yearly</option>
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">Subscription Duration (days)</label>
                <input type="number" className="form-control" value={form.subscription_days} onChange={e => set('subscription_days', e.target.value)} />
                <small style={{ color: 'var(--text-light)', fontSize: '11px' }}>Monthly=30, Quarterly=90, Yearly=365</small>
              </div>
            </div>

            <div style={{ marginTop: '8px' }}>
              <button className="btn btn-primary btn-lg" type="submit" disabled={loading}>
                {loading ? 'Creating...' : '✅ Shop Banao Aur Save Karein'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
